var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Divider, Grid, IconButton, Menu, MenuItem, TextField, Typography } from '@mui/material';
import { GridCloseIcon } from '@mui/x-data-grid-premium';
import { t } from 'i18next';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { UploadImage } from '../../../../api/api';
import { Config } from '../../../../api/config';
import { ProductConditionImageViewUrl, dynamicFormControlsListUrl, getPrecheckListByInstallBaseIdUrl, precheckDynamicCheckListFormUrl } from '../../../../api/url';
import { GalleryIcon } from '../../../../assets/customIcons';
import { BlueDropdownIcon } from '../../../../assets/images';
import { MuiStack } from '../../../../components';
import { MuiCheckBox } from '../../../../components/atoms/checkBox';
import { MuiImagePopUp } from '../../../../components/atoms/imageDialogBox';
import { MuiLoaderButton } from '../../../../components/atoms/loaderButton';
import { ImageViewCustomTabs } from '../../../../components/templates/ImageViewCustomTabs';
import CustomFormFuelIndicator from '../../../../components/templates/precheckCustomForm/customFormFuelIndicator';
import PrecheckCustomForm from '../../../../components/templates/precheckCustomForm/precheckCustomForm';
import ImageCapture from '../../../../components/templates/translateToJob/imageCapture';
import { EFaultType, EModuleSection, EParentModuleName, E_VehicleConditionView, LOCAL_STORAGE_KEYS, Module, VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR, isModuleConfig } from '../../../../constants';
import { downloadAttachment, setIsFuelIndicatorSliderChanged, setIsTaskDetailsDataUpdated, setSavedTaskDetailsCount, setTaskDetailsDataSaved, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../../redux/commonSlice';
import { getByIdAPI, getListAPI, setState } from '../../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { systemColor } from '../../../../theme/systemColor';
import { getLocalStorageItem, setLocalStorageItem } from '../../../../utils/storageHelper';
import { sortImagesByTimeStamp } from '../../../../utils/utils';
import useAnalyticsEventTracker from '../../../../utils/useAnalyticsEventTracker';
var E_ChekcListType = /*#__PURE__*/ function (E_ChekcListType) {
    E_ChekcListType["FuelIndicatorList"] = "FuelIndicator";
    E_ChekcListType["DynamicChecklist"] = "DynamicChecklist";
    return E_ChekcListType;
}(E_ChekcListType || {});
var PreCheckCommonComponent = function (props) {
    var _values$imageList, _values$imageList2;
    var trackButtonClick = useAnalyticsEventTracker("PreCheckCommonComponent");
    var setFuelCallBack = props.setFuelCallBack, parentModuleDocumentId = props.parentModuleDocumentId, getSavedFuelPercentageUrl = props.getSavedFuelPercentageUrl, parentModuleName = props.parentModuleName, upsertFuelPercentageUrl = props.upsertFuelPercentageUrl, installBaseId = props.installBaseId, callApIStatus = props.callApIStatus, apiRequestParam = props.apiRequestParam, apiRequestPayload = props.apiRequestPayload, SystemName = props.SystemName, _a = props.isSaveButton, isSaveButton = _a === void 0 ? true : _a, isFromTaskDetails = props.isFromTaskDetails, isDisabled = props.isDisabled, sendDataToParent = props.sendDataToParent, fuelIdicatorDynamicListData = props.fuelIdicatorDynamicListData, precheckQuestionsAnswerData = props.precheckQuestionsAnswerData;
    var dispatch = useAppDispatch();
    var _b = useState([]), preCheckList = _b[0], setPrecheckList = _b[1];
    // const [complaintsPhotographList, setcomplaintsPhotographList] = useState<IImageDetails[]>([]);
    var _c = useState([]), precheckDynamicList = _c[0], setPrecheckDynamicList = _c[1];
    // Add local state for fuel indicator data
    var _d = useState([]), localFuelIndicatorData = _d[0], setLocalFuelIndicatorData = _d[1];
    // const [fuelIdicatorDynamicListPrecheck, setFuelIndicatorDynamicListPrecheck] = useState<IQuestionGroupItem[]>([])
    var _e = useState([]), removedImageList = _e[0], setRemovedImageList = _e[1];
    // const [saRemarks, setSaRemarks] = useState<string>("")
    var ModuleDetailsGetById = useSelector(function (state) { return state.crud; }).ModuleDetailsGetById;
    var _f = useSelector(function (state) { return state.common; }), getSavedTaskDetailsCount = _f.getSavedTaskDetailsCount, updatedModuleSectionByChannel = _f.updatedModuleSectionByChannel;
    var _g = useState(0), saveCount = _g[0], setSaveCount = _g[1];
    var _h = useState([]), precheckDynamicListReplica = _h[0], setPrecheckDynamicListReplica = _h[1];
    var _j = useState(false), openImageGallery = _j[0], setOpenImageGallery = _j[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var _k = useState(false), isDrawerOpen = _k[0], setISDrawerOpen = _k[1];
    var _l = useState(''), imageURL = _l[0], setImageURL = _l[1];
    var _m = useState([]), removedImages = _m[0], setRemovedImages = _m[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _o = useState({
        imageList: [],
        description: "",
        audio: {
            audioBlobUrl: '',
            audioFile: ''
        }
    }), values = _o[0], setValues = _o[1];
    var _p = useState([]), imageViewTypesTabs = _p[0], setImageViewTypesTabs = _p[1];
    var _q = useState(E_VehicleConditionView.Image), selectedViewType = _q[0], setSelectedViewType = _q[1];
    var _r = useState(null), anchorEl = _r[0], setAnchorEl = _r[1];
    useEffect(function () {
        if (callApIStatus && ModuleDetailsGetById.data && precheckQuestionsAnswerData) {
            initiate();
        }
    }, [callApIStatus, ModuleDetailsGetById, precheckQuestionsAnswerData]);
    // Initialize local fuel indicator data when props change
    useEffect(function () {
        if (fuelIdicatorDynamicListData) {
            setLocalFuelIndicatorData(__spreadArray([], fuelIdicatorDynamicListData, true));
        }
    }, [fuelIdicatorDynamicListData]);
    // Reset fuelIndicatorSaved when local data changes (indicating unsaved changes)
    useEffect(function () {
        if (localFuelIndicatorData.length > 0 && fuelIdicatorDynamicListData.length > 0) {
            var _localFuelIndicatorDa;
            // Check if local data differs from the original prop data by comparing ResponseValue as numbers
            var hasChanges = (_localFuelIndicatorDa = localFuelIndicatorData[0]) === null || _localFuelIndicatorDa === void 0 || (_localFuelIndicatorDa = _localFuelIndicatorDa.Questions) === null || _localFuelIndicatorDa === void 0 ? void 0 : _localFuelIndicatorDa.some(function (localQuestion, index) {
                var _fuelIdicatorDynamicL;
                var originalQuestion = (_fuelIdicatorDynamicL = fuelIdicatorDynamicListData[0]) === null || _fuelIdicatorDynamicL === void 0 || (_fuelIdicatorDynamicL = _fuelIdicatorDynamicL.Questions) === null || _fuelIdicatorDynamicL === void 0 ? void 0 : _fuelIdicatorDynamicL[index];
                if (!originalQuestion)
                    return true;
                // Convert both values to numbers for comparison
                var localValue = typeof localQuestion.ResponseValue === 'string' ? parseInt(localQuestion.ResponseValue) || 0 : localQuestion.ResponseValue || 0;
                var originalValue = typeof originalQuestion.ResponseValue === 'string' ? parseInt(originalQuestion.ResponseValue) || 0 : originalQuestion.ResponseValue || 0;
                return localValue !== originalValue;
            });
            if (hasChanges) {
                dispatch(setState({
                    key: "fuelIndicatorSaved",
                    value: false
                }));
            }
        }
    }, [localFuelIndicatorData, fuelIdicatorDynamicListData, dispatch]);
    var initiate = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, Promise.all([
                            // getFuelLevel(),
                            getPrecheckList(), getDynamicCheckListFormQuestions(), getSABoxData()
                        ])];
                case 1:
                    _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
    var getSABoxData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _responseData$payload, _responseData$payload2, _responseData$payload3, DownloadAttachmentUrl, responseData, _responseData$payload4, _responseData$payload5, _responseData$payload6, attachmentTobeDownload, imageAttachementURLs_1, audioAttachementURLs, imageAttachmentsUrlWithMediaType1_1, audioAttachmentsUrlWithMediaType2_1, downloadImagePromise, downloadAudioPromise, sortedImages, _responseData$payload7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    DownloadAttachmentUrl = "".concat(Config.baseURL, "resource/PreJobCardDocument/");
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: "".concat(Config.baseURL, "PreJobCardDocument/").concat(parentModuleDocumentId, "/SAPreCheckComments")
                        }))];
                case 1:
                    responseData = _a.sent();
                    if (!(responseData !== null && responseData !== void 0 && (_responseData$payload = responseData.payload) !== null && _responseData$payload !== void 0 && _responseData$payload.success && responseData !== null && responseData !== void 0 && (_responseData$payload2 = responseData.payload) !== null && _responseData$payload2 !== void 0 && _responseData$payload2.data && responseData !== null && responseData !== void 0 && (_responseData$payload3 = responseData.payload) !== null && _responseData$payload3 !== void 0 && (_responseData$payload3 = _responseData$payload3.data) !== null && _responseData$payload3 !== void 0 && _responseData$payload3.SAComments)) return [3 /*break*/, 5];
                    if (!((responseData === null || responseData === void 0 || (_responseData$payload4 = responseData.payload) === null || _responseData$payload4 === void 0 || (_responseData$payload4 = _responseData$payload4.data.SAComments) === null || _responseData$payload4 === void 0 || (_responseData$payload4 = _responseData$payload4.SABoxAttachments) === null || _responseData$payload4 === void 0 ? void 0 : _responseData$payload4.length) > 0)) return [3 /*break*/, 4];
                    attachmentTobeDownload = responseData === null || responseData === void 0 || (_responseData$payload5 = responseData.payload) === null || _responseData$payload5 === void 0 || (_responseData$payload5 = _responseData$payload5.data.SAComments) === null || _responseData$payload5 === void 0 ? void 0 : _responseData$payload5.SABoxAttachments;
                    imageAttachementURLs_1 = [];
                    audioAttachementURLs = [];
                    imageAttachmentsUrlWithMediaType1_1 = [];
                    audioAttachmentsUrlWithMediaType2_1 = [];
                    attachmentTobeDownload.map(function (element, index) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            if (element.MediaType === 1) {
                                imageAttachmentsUrlWithMediaType1_1.push(element);
                            }
                            if (element.MediaType === 2) {
                                audioAttachmentsUrlWithMediaType2_1.push(element);
                            }
                            return [2 /*return*/];
                        });
                    }); });
                    downloadImagePromise = imageAttachmentsUrlWithMediaType1_1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 2];
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, parentModuleDocumentId, DownloadAttachmentUrl)];
                                case 1:
                                    base64 = _a.sent();
                                    imageAttachementURLs_1.push({
                                        blobUrl: base64,
                                        AttachmentId: imageItem.AttachmentId,
                                        isAlreadyUploaded: true,
                                        _ts: imageItem._ts
                                    });
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    console.log("error", error_1);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    downloadAudioPromise = audioAttachmentsUrlWithMediaType2_1.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var base64, error_2;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 3, , 4]);
                                    if (!imageItem.AttachmentId) return [3 /*break*/, 2];
                                    return [4 /*yield*/, downloadAttachment(imageItem.AttachmentId, parentModuleDocumentId, DownloadAttachmentUrl)];
                                case 1:
                                    base64 = _a.sent();
                                    audioAttachementURLs.push({
                                        audioBlobUrl: base64,
                                        AttachmentId: imageItem.AttachmentId,
                                        isAlreadyUploaded: true
                                    });
                                    _a.label = 2;
                                case 2: return [3 /*break*/, 4];
                                case 3:
                                    error_2 = _a.sent();
                                    console.log("error", error_2);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, Promise.all(downloadAudioPromise)];
                case 3:
                    _a.sent();
                    sortedImages = sortImagesByTimeStamp(imageAttachementURLs_1);
                    setValues(_objectSpread(_objectSpread({}, values), {}, {
                        description: responseData === null || responseData === void 0 || (_responseData$payload6 = responseData.payload) === null || _responseData$payload6 === void 0 || (_responseData$payload6 = _responseData$payload6.data) === null || _responseData$payload6 === void 0 || (_responseData$payload6 = _responseData$payload6.SAComments) === null || _responseData$payload6 === void 0 ? void 0 : _responseData$payload6.Comments,
                        imageList: sortedImages,
                        audio: audioAttachementURLs.length > 0 ? audioAttachementURLs[0] : null
                    }));
                    return [3 /*break*/, 5];
                case 4:
                    setValues(_objectSpread(_objectSpread({}, values), {}, {
                        description: responseData === null || responseData === void 0 || (_responseData$payload7 = responseData.payload) === null || _responseData$payload7 === void 0 || (_responseData$payload7 = _responseData$payload7.data) === null || _responseData$payload7 === void 0 || (_responseData$payload7 = _responseData$payload7.SAComments) === null || _responseData$payload7 === void 0 ? void 0 : _responseData$payload7.Comments
                    }));
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getProductContitionValues = function () { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPayload, precheckListResult;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedPayload = _objectSpread(_objectSpread({}, apiRequestPayload), {}, {
                        SystemName: "ProductConditionCheckListItem"
                    });
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "",
                            url: "".concat(Config.baseURL + apiRequestParam, "/InspectionProductContitionValues"),
                            request: updatedPayload
                        }))];
                case 1:
                    precheckListResult = _a.sent();
                    if (precheckListResult.payload.success && precheckListResult.payload.data) {
                        // if (precheckListResult.payload.data.ImageAttachments && precheckListResult.payload.data.ImageAttachments.length > 0) {
                        //   let imagesTobeDownload = precheckListResult.payload.data.ImageAttachments
                        //   let downloadedImages: any = []
                        //   const downloadImagePromise = imagesTobeDownload?.map(async (el: any, idx: any) => {
                        //     const downloadImages = async () => {
                        //       try {
                        //         const base64: any = await downloadAttachment(el.AttachmentId, el.id, getDownloadPreJobCardDocumentAttachmentUrl);
                        //         downloadedImages.push({
                        //           isAlreadyUploaded: true,
                        //           attachmentId: el.AttachmentId,
                        //           blobUrl: base64,
                        //           file: null
                        //         })
                        //       } catch (error) {
                        //         console.error("Precheck :: downloadedImagesError :: ", error);
                        //       }
                        //     }
                        //     await downloadImages();
                        //   })
                        //   await Promise.all(downloadImagePromise);
                        // }
                        return [2 /*return*/, precheckListResult.payload.data.InspectionValues];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getPrecheckList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById, _ModuleDetailsGetById2, _a, precheckListResult, savedItemsList, _precheckListResult$p, _precheckListResult$p2, _data$ProductConditio, mastersItemsList, AlhpabeticallySortedMasterList, newArray_1, viewIdMap_1, data, _data$ProductConditio2, downloadImagePromise, final;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([dispatch(getByIdAPI({
                            key: "",
                            url: getPrecheckListByInstallBaseIdUrl((_ModuleDetailsGetById = ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.ProductId) !== null && _ModuleDetailsGetById !== void 0 ? _ModuleDetailsGetById : "")
                        })), getProductContitionValues()])];
                case 1:
                    _a = _b.sent(), precheckListResult = _a[0], savedItemsList = _a[1];
                    if (!(precheckListResult !== null && precheckListResult !== void 0 && precheckListResult.payload.success && precheckListResult !== null && precheckListResult !== void 0 && precheckListResult.payload.data)) return [3 /*break*/, 3];
                    mastersItemsList = precheckListResult !== null && precheckListResult !== void 0 && (_precheckListResult$p = precheckListResult.payload) !== null && _precheckListResult$p !== void 0 && (_precheckListResult$p = _precheckListResult$p.data) !== null && _precheckListResult$p !== void 0 && _precheckListResult$p.ProductConditionCheckListItemList ? __spreadArray([], (precheckListResult === null || precheckListResult === void 0 || (_precheckListResult$p2 = precheckListResult.payload) === null || _precheckListResult$p2 === void 0 || (_precheckListResult$p2 = _precheckListResult$p2.data) === null || _precheckListResult$p2 === void 0 ? void 0 : _precheckListResult$p2.ProductConditionCheckListItemList), true) : [];
                    AlhpabeticallySortedMasterList = mastersItemsList.sort(function (a, b) { return a.Question.localeCompare(b.Question); });
                    newArray_1 = [];
                    AlhpabeticallySortedMasterList.forEach(function (item) {
                        var exists = savedItemsList.some(function (existItem) { return existItem.ProductConditionCheckListItemId === item.ProductConditionCheckListItemId; });
                        if (exists) {
                            var matchedReqItem_1 = savedItemsList.find(function (existItem) { return existItem.ProductConditionCheckListItemId === item.ProductConditionCheckListItemId; });
                            var images = [];
                            var newItem = {
                                "ProductConditionCheckListItemId": item.ProductConditionCheckListItemId,
                                "Question": item.Question,
                                "Answers": item.Answers.map(function (answer) { return _objectSpread(_objectSpread({}, answer), {}, {
                                    defaultValue: answer.Key === matchedReqItem_1.AnswerKey
                                }); }),
                                "ImageXPostion": item.ImageXPostion,
                                "ImageYPostion": item.ImageYPostion,
                                "ProductConditionCheckListId": item.ProductConditionCheckListId,
                                "ProductConditionViewId": item.ProductConditionViewId,
                                "Remark": matchedReqItem_1.Remarks,
                                images: images
                            };
                            newArray_1.push(newItem);
                        }
                        else {
                            newArray_1.push(item);
                        }
                    });
                    setPrecheckList(newArray_1);
                    viewIdMap_1 = {};
                    data = precheckListResult === null || precheckListResult === void 0 ? void 0 : precheckListResult.payload.data;
                    // Grouping objects by ProductConditionViewId
                    newArray_1.forEach(function (item) {
                        var viewId = item.ProductConditionViewId;
                        if (viewId) {
                            if (!viewIdMap_1[viewId]) {
                                viewIdMap_1[viewId] = [];
                            }
                            viewIdMap_1[viewId].push(item);
                        }
                    });
                    if (!(data !== null && data !== void 0 && data.ProductConditionViewList && Array.isArray(data === null || data === void 0 ? void 0 : data.ProductConditionViewList) && (data === null || data === void 0 || (_data$ProductConditio = data.ProductConditionViewList) === null || _data$ProductConditio === void 0 ? void 0 : _data$ProductConditio.length) > 0)) return [3 /*break*/, 3];
                    downloadImagePromise = data === null || data === void 0 || (_data$ProductConditio2 = data.ProductConditionViewList) === null || _data$ProductConditio2 === void 0 ? void 0 : _data$ProductConditio2.map(function (viewItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var ImageAttachment, base64, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    ImageAttachment = "";
                                    if (!viewItem.UploadAttachementId) return [3 /*break*/, 4];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, downloadAttachment(viewItem.UploadAttachementId, viewItem.ProductConditionViewId, ProductConditionImageViewUrl)];
                                case 2:
                                    base64 = _a.sent();
                                    ImageAttachment = base64;
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_3 = _a.sent();
                                    console.error("error", error_3);
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/, _objectSpread(_objectSpread({}, viewItem), {}, {
                                        ImageAttachment: ImageAttachment,
                                        checkListItems: viewIdMap_1[viewItem.ProductConditionViewId] || []
                                    })];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(downloadImagePromise)];
                case 2:
                    final = _b.sent();
                    setImageViewTypesTabs(final);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getControlsList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var controlList, controlListForm;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    controlList = getLocalStorageItem(LOCAL_STORAGE_KEYS.PRECHECK_FORM_CONTROL_LIST);
                    if (!controlList) return [3 /*break*/, 1];
                    return [2 /*return*/, controlList];
                case 1: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "",
                        url: dynamicFormControlsListUrl
                    }))];
                case 2:
                    controlListForm = _a.sent();
                    if (controlListForm.payload.success) {
                        setLocalStorageItem(LOCAL_STORAGE_KEYS.PRECHECK_FORM_CONTROL_LIST, controlListForm.payload.data);
                        return [2 /*return*/, controlListForm.payload.data];
                    }
                    else {
                        return [2 /*return*/, []];
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getDynamicCheckListFormQuestions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById3, requestBody, QuestionsResponse, controlTypesList_1, QuestionsList, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {
                        "SystemName": SystemName,
                        "ProductId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.ProductId,
                        "OrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: precheckDynamicCheckListFormUrl,
                            request: requestBody
                        }))];
                case 1:
                    QuestionsResponse = _a.sent();
                    if (!QuestionsResponse.payload.value.success) return [3 /*break*/, 3];
                    return [4 /*yield*/, Promise.all([getControlsList()])];
                case 2:
                    controlTypesList_1 = (_a.sent())[0];
                    QuestionsList = QuestionsResponse.payload.value.data;
                    result = QuestionsList.map(function (questionGroupItem) {
                        if (questionGroupItem.Questions && questionGroupItem.Questions.length > 0) {
                            var SortedQuestionsBySequence = __spreadArray([], questionGroupItem.Questions, true).sort(function (a, b) { return a.Sequence - b.Sequence; });
                            return _objectSpread(_objectSpread({}, questionGroupItem), {}, {
                                Questions: SortedQuestionsBySequence.map(function (questionItem) {
                                    var questionControlType = controlTypesList_1.find(function (item) { return item.id === questionItem.ControlId; });
                                    var questionAnswerItem = precheckQuestionsAnswerData === null || precheckQuestionsAnswerData === void 0 ? void 0 : precheckQuestionsAnswerData.find(function (item) { return (item === null || item === void 0 ? void 0 : item.QuestionId) === (questionItem === null || questionItem === void 0 ? void 0 : questionItem.QuestionId); });
                                    return _objectSpread(_objectSpread({}, questionItem), {}, {
                                        ControlName: questionControlType && questionControlType.DisplayName ? questionControlType.DisplayName : '',
                                        ResponseValue: questionAnswerItem && questionAnswerItem.ResponseValue ? questionAnswerItem.ResponseValue : ''
                                    });
                                })
                            });
                        }
                    });
                    setPrecheckDynamicList(result);
                    setPrecheckDynamicListReplica(result);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getChecked = function (dataArray, faultType) {
        var scratchObject = dataArray.find(function (item) { return item.Key === faultType; });
        if (scratchObject) {
            var isScratchDefaultValueTrue = scratchObject.defaultValue;
            return isScratchDefaultValueTrue;
        }
        else {
            return false;
        }
    };
    var updateDefaultValue = function (answersArray, keyToUpdate) {
        // Create a deep copy of the input array and objects
        var newArray = JSON.parse(JSON.stringify(answersArray));
        // Find the object with the specified key in the Answers array
        var answerObject = newArray.find(function (answer) { return answer.Key === keyToUpdate; });
        // If the object is found, update the defaultValue
        if (answerObject) {
            answerObject.defaultValue = !answerObject.defaultValue;
            // Unchecking other boxes
            newArray.forEach(function (answer) {
                if (answer.Key !== keyToUpdate) {
                    answer.defaultValue = false;
                }
            });
        }
        // Return the updated array
        return newArray;
    };
    var handleCheckboxChange = function (id, index, faultType) {
        var updatedList = __spreadArray([], preCheckList, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        var updatedAnswers = updateDefaultValue(updatedItem.Answers, faultType);
        updatedItem.Answers = updatedAnswers;
        updatedList[index] = updatedItem;
        setPrecheckList(updatedList);
        updatedAnswers.map(function (item) {
            if (item !== null && item !== void 0 && item.defaultValue) {
                setSaveCount(saveCount + 1);
            }
        });
        dispatch(setIsTaskDetailsDataUpdated(true));
        var updatedViewGroups = __spreadArray([], imageViewTypesTabs, true);
        var updateGroupItemIndex = updatedViewGroups.findIndex(function (item) { return item.ProductConditionViewId === updatedItem.ProductConditionViewId; });
        if (updateGroupItemIndex > -1) {
            var updateGroupItem = _objectSpread({}, updatedViewGroups[updateGroupItemIndex]);
            var updatedItemIndex = updateGroupItem.checkListItems.findIndex(function (item) { return item.ProductConditionCheckListItemId === updatedItem.ProductConditionCheckListItemId; });
            if (updatedItemIndex > -1) {
                var updatedItem_1 = _objectSpread({}, updateGroupItem.checkListItems[updatedItemIndex]);
                var updatedAnswers_1 = updateDefaultValue(updatedItem_1.Answers, faultType);
                updatedItem_1.Answers = updatedAnswers_1;
                updateGroupItem.checkListItems[updatedItemIndex] = updatedItem_1;
                updatedViewGroups[updateGroupItemIndex] = updateGroupItem;
            }
        }
        setImageViewTypesTabs(updatedViewGroups);
    };
    var handleImageViewConditionChange = function (selectedItem, faultType) {
        var updatedList = __spreadArray([], preCheckList, true);
        var updatedItemIndex = updatedList.findIndex(function (item) { return item.ProductConditionCheckListItemId === selectedItem.ProductConditionCheckListItemId; });
        if (updatedItemIndex > -1) {
            var updatedItem = _objectSpread({}, updatedList[updatedItemIndex]);
            var updatedAnswers = updateDefaultValue(updatedItem.Answers, faultType);
            updatedItem.Answers = updatedAnswers;
            updatedList[updatedItemIndex] = updatedItem;
            setPrecheckList(updatedList);
            updatedAnswers.map(function (item) {
                if (item !== null && item !== void 0 && item.defaultValue) {
                    setSaveCount(saveCount + 1);
                }
            });
            dispatch(setIsTaskDetailsDataUpdated(true));
        }
        var updatedViewGroups = __spreadArray([], imageViewTypesTabs, true);
        var updateGroupItemIndex = updatedViewGroups.findIndex(function (item) { return item.ProductConditionViewId === selectedItem.ProductConditionViewId; });
        if (updateGroupItemIndex > -1) {
            var updateGroupItem = _objectSpread({}, updatedViewGroups[updateGroupItemIndex]);
            var updatedItemIndex_1 = updateGroupItem.checkListItems.findIndex(function (item) { return item.ProductConditionCheckListItemId === selectedItem.ProductConditionCheckListItemId; });
            if (updatedItemIndex_1 > -1) {
                var updatedItem = _objectSpread({}, updateGroupItem.checkListItems[updatedItemIndex_1]);
                var updatedAnswers = updateDefaultValue(updatedItem.Answers, faultType);
                updatedItem.Answers = updatedAnswers;
                updateGroupItem.checkListItems[updatedItemIndex_1] = updatedItem;
                updatedViewGroups[updateGroupItemIndex] = updateGroupItem;
            }
        }
        setImageViewTypesTabs(updatedViewGroups);
    };
    var uploadAttachmentUsingId = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, UploadImage("".concat(Config.baseURL, "resource/PreJobCardDocument/").concat(parentModuleDocumentId), data, 'BlankSystemName', dispatch)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    }); };
    var saveSAPrecheckObservation = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _values$audio, _SAResult$payload, ImageAttachmentsBody_1, audioFiles, upsertData_1, _values$imageList$fil, _audioFiles$filter, uploadPromises, uploadPromises1, requestBody, SAResult, sortedList_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 9]);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    ImageAttachmentsBody_1 = [];
                    if ((values === null || values === void 0 ? void 0 : values.imageList.length) > 0) {
                        values === null || values === void 0 || values.imageList.map(function (imageItem) {
                            if (!imageItem.isAlreadyUploaded) {
                                ImageAttachmentsBody_1.push({
                                    SystemName: "CustomerVoiceWiseComment",
                                    MediaType: 1
                                });
                            }
                        });
                    }
                    audioFiles = values !== null && values !== void 0 && (_values$audio = values.audio) !== null && _values$audio !== void 0 && _values$audio.audioBlobUrl ? [values === null || values === void 0 ? void 0 : values.audio] : [];
                    if (audioFiles.length > 0) {
                        audioFiles.map(function (audioFile) {
                            ImageAttachmentsBody_1.push({
                                SystemName: "CustomerVoiceWiseComment",
                                MediaType: 2
                            });
                        });
                    }
                    upsertData_1 = [];
                    if (!(ImageAttachmentsBody_1.length > 0)) return [3 /*break*/, 4];
                    uploadPromises = values === null || values === void 0 || (_values$imageList$fil = values.imageList.filter(function (f) { return !f.isAlreadyUploaded; })) === null || _values$imageList$fil === void 0 ? void 0 : _values$imageList$fil.map(function (imageItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', imageItem === null || imageItem === void 0 ? void 0 : imageItem.file);
                                    return [4 /*yield*/, uploadAttachmentUsingId(formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.statusCode && result !== null && result !== void 0 && result.statusCode) {
                                        upsertData_1.push({
                                            AttachmentId: result === null || result === void 0 ? void 0 : result.attachmentId,
                                            SystemName: "CustomerVoiceWiseComment",
                                            MediaType: 1
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises)];
                case 2:
                    _a.sent();
                    uploadPromises1 = audioFiles === null || audioFiles === void 0 || (_audioFiles$filter = audioFiles.filter(function (f) { return !f.isAlreadyUploaded; })) === null || _audioFiles$filter === void 0 ? void 0 : _audioFiles$filter.map(function (audioItem, index) { return __awaiter(void 0, void 0, void 0, function () {
                        var formData, result;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    formData = new FormData();
                                    formData.append('data', audioItem === null || audioItem === void 0 ? void 0 : audioItem.audioFile);
                                    return [4 /*yield*/, uploadAttachmentUsingId(formData)];
                                case 1:
                                    result = _a.sent();
                                    if (result !== null && result !== void 0 && result.statusCode && result !== null && result !== void 0 && result.statusCode) {
                                        upsertData_1.push({
                                            AttachmentId: result === null || result === void 0 ? void 0 : result.attachmentId,
                                            SystemName: "CustomerVoiceWiseComment",
                                            MediaType: 2
                                        });
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(uploadPromises1)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    requestBody = _objectSpread(_objectSpread({}, apiRequestPayload), {}, {
                        SAComments: [{
                                ParentId: parentModuleDocumentId,
                                Comments: values.description,
                                ImageAttachments: upsertData_1
                            }]
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: "".concat(Config.baseURL).concat(apiRequestParam, "/UpsertSAComments"),
                            request: requestBody
                        }))];
                case 5:
                    SAResult = _a.sent();
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 6:
                    _a.sent();
                    if (SAResult !== null && SAResult !== void 0 && (_SAResult$payload = SAResult.payload) !== null && _SAResult$payload !== void 0 && (_SAResult$payload = _SAResult$payload.value) !== null && _SAResult$payload !== void 0 && _SAResult$payload.success) {
                        sortedList_1 = [];
                        updatedModuleSectionByChannel.map(function (item) {
                            var data = cloneDeep(item);
                            if (item.Key == EModuleSection.Precheck) {
                                if (Module === isModuleConfig.Product) {
                                    data.SectionAttributes[0].MANDATORY = true;
                                    data.SectionAttributes[0].MANDATORYDefaultValue = true;
                                }
                            }
                            sortedList_1.push(data);
                        });
                        dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
                    }
                    return [3 /*break*/, 9];
                case 7:
                    e_1 = _a.sent();
                    console.log(e_1);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 8:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var saveVehiclePrecheckValues = function (updloadedAttachments, remark) { return __awaiter(void 0, void 0, void 0, function () {
        var _values$description, inspectionValues, imagePayload, requestBody, saveVehicleInspectionResponse, finalCount, sortedList_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inspectionValues = [];
                    imagePayload = [];
                    if (updloadedAttachments) {
                        updloadedAttachments.map(function (imageItem) {
                            imagePayload.push({
                                "AttachmentId": imageItem.attachmentId,
                                "MediaType": 1,
                                "SystemName": "ProductConditionCheckListItem"
                            });
                        });
                    }
                    preCheckList.forEach(function (item) {
                        var updateValue = {
                            "ProductConditionCheckListItemId": item.ProductConditionCheckListItemId,
                            "ResponseValue": "true",
                            "AnswerKey": ""
                        };
                        item.Answers.forEach(function (answer) {
                            if (answer.defaultValue) {
                                updateValue.AnswerKey = answer.Key;
                                inspectionValues.push(updateValue);
                            }
                        });
                    });
                    requestBody = {
                        "ImageAttachments": imagePayload,
                        "Remarks": (_values$description = values.description) !== null && _values$description !== void 0 ? _values$description : ""
                    };
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        requestBody.EstimateId = parentModuleDocumentId;
                        requestBody.InspectionValues = inspectionValues;
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        requestBody.InspectionId = parentModuleDocumentId;
                        requestBody.InspectionValues = inspectionValues;
                    }
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: "".concat(Config.baseURL + apiRequestParam, "/UpsertInspectionProductContitionValue"),
                            request: requestBody
                        }))];
                case 1:
                    saveVehicleInspectionResponse = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (!saveVehicleInspectionResponse.payload.value.success) return [3 /*break*/, 3];
                    finalCount = getSavedTaskDetailsCount.preCheckCount + saveCount;
                    return [4 /*yield*/, dispatch(setSavedTaskDetailsCount({
                            preCheckCount: finalCount
                        }))];
                case 2:
                    _a.sent();
                    dispatch(setTaskDetailsDataSaved(true));
                    sortedList_2 = [];
                    updatedModuleSectionByChannel.map(function (item) {
                        var data = cloneDeep(item);
                        if (item.Key == EModuleSection.Precheck) {
                            if (Module === isModuleConfig.Product) {
                                data.SectionAttributes[0].MANDATORY = true;
                                data.SectionAttributes[0].MANDATORYDefaultValue = true;
                            }
                        }
                        sortedList_2.push(data);
                    });
                    dispatch(setUpdatedModuleSectionByChannel(sortedList_2));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var savePrecheckDynamicFormValues = function (list, listType) { return __awaiter(void 0, void 0, void 0, function () {
        var FilledValues, _saveFormValuesRespon, _saveFormValuesRespon2, requestBody, saveFormValuesResponse, sortedList_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    FilledValues = [];
                    if (!(list && list.length > 0)) return [3 /*break*/, 2];
                    list.map(function (questionGrpItem) {
                        questionGrpItem.Questions.map(function (questionItem) {
                            if (listType === E_ChekcListType.DynamicChecklist && questionItem.ResponseValue) {
                                var _questionItem$Respons;
                                FilledValues.push({
                                    QuestionId: questionItem.QuestionId,
                                    ResponseValue: (_questionItem$Respons = questionItem.ResponseValue) === null || _questionItem$Respons === void 0 ? void 0 : _questionItem$Respons.toString()
                                });
                            }
                            else if (listType === E_ChekcListType.FuelIndicatorList) {
                                var _questionItem$Respons2;
                                FilledValues.push({
                                    QuestionId: questionItem.QuestionId,
                                    ResponseValue: questionItem.ResponseValue ? (_questionItem$Respons2 = questionItem.ResponseValue) === null || _questionItem$Respons2 === void 0 ? void 0 : _questionItem$Respons2.toString() : "0"
                                });
                            }
                        });
                    });
                    requestBody = _objectSpread({
                        "Options": FilledValues
                    }, apiRequestPayload);
                    // buttonClickSpan.end();
                    // pageLoadSpan.end();
                    // transaction.end();
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: "".concat(Config.baseURL + apiRequestParam, "/UpsertInspectionPreCheckList"),
                            request: requestBody
                        }))];
                case 1:
                    saveFormValuesResponse = _a.sent();
                    if (saveFormValuesResponse !== null && saveFormValuesResponse !== void 0 && (_saveFormValuesRespon = saveFormValuesResponse.payload) !== null && _saveFormValuesRespon !== void 0 && (_saveFormValuesRespon = _saveFormValuesRespon.value) !== null && _saveFormValuesRespon !== void 0 && _saveFormValuesRespon.success && (saveFormValuesResponse === null || saveFormValuesResponse === void 0 || (_saveFormValuesRespon2 = saveFormValuesResponse.payload) === null || _saveFormValuesRespon2 === void 0 || (_saveFormValuesRespon2 = _saveFormValuesRespon2.value) === null || _saveFormValuesRespon2 === void 0 ? void 0 : _saveFormValuesRespon2.statusCode) == 200) {
                        dispatch(setTaskDetailsDataSaved(true));
                        sortedList_3 = [];
                        updatedModuleSectionByChannel.map(function (item) {
                            var data = cloneDeep(item);
                            if (item.Key == EModuleSection.Precheck) {
                                if (Module === isModuleConfig.Product) {
                                    data.SectionAttributes[0].MANDATORY = true;
                                    data.SectionAttributes[0].MANDATORYDefaultValue = true;
                                }
                            }
                            sortedList_3.push(data);
                        });
                        dispatch(setUpdatedModuleSectionByChannel(sortedList_3));
                        dispatch(showNotification({
                            isOpen: true,
                            message: t('PRECHECK_SAVE_MSG'),
                            type: "success"
                        }));
                        if (listType === E_ChekcListType.FuelIndicatorList) {
                            dispatch(setState({
                                key: "fuelIndicatorSaved",
                                value: true
                            }));
                        }
                    }
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [2 /*return*/, saveFormValuesResponse];
                case 2: return [2 /*return*/, false];
            }
        });
    }); };
    var deleteImages = function () { return __awaiter(void 0, void 0, void 0, function () {
        var deletePromise;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    deletePromise = removedImages.map(function (imageItem) { return __awaiter(void 0, void 0, void 0, function () {
                        var request, DeleteAttchementResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!imageItem.isAlreadyUploaded) return [3 /*break*/, 2];
                                    request = {
                                        SystemName: "CustomerVoiceWiseComment",
                                        ParentId: parentModuleDocumentId,
                                        AttachmentId: imageItem.AttachmentId,
                                        PreJobCardDocumentId: parentModuleDocumentId
                                    };
                                    return [4 /*yield*/, dispatch(getListAPI({
                                            key: "",
                                            url: "".concat(Config.baseURL, "PreJobCardDocumentAttachment/DeleteSAAttachment"),
                                            request: request
                                        }))];
                                case 1:
                                    DeleteAttchementResponse = _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(deletePromise)];
                case 1:
                    _a.sent();
                    setRemovedImages([]);
                    return [2 /*return*/];
            }
        });
    }); };
    var onClickSave = function () {
        trackButtonClick("ButtonClickEvent", "Precheck_Save", undefined);
        // Update parent with current local fuel indicator data
        setFuelCallBack(localFuelIndicatorData);
        dispatch(setIsFuelIndicatorSliderChanged(false));
        // setFuelIndicatorDynamicList(fuelIdicatorDynamicListData)
        // saveFuelPercentage()
        savePrecheckDynamicFormValues(localFuelIndicatorData, E_ChekcListType.FuelIndicatorList);
        savePrecheckDynamicFormValues(precheckDynamicList, E_ChekcListType.DynamicChecklist);
        saveVehiclePrecheckValues([], "");
        deleteImages();
        saveSAPrecheckObservation();
    };
    var handleOpenGalleryClick = function () {
        trackButtonClick("ButtonClickEvent", "OpenGallary_Click", undefined);
        setOpenImageGallery(function (prev) { return !prev; });
    };
    var handleImageList = function (imagesList, removedImageList) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            trackButtonClick("ButtonClickEvent", "ImageList_Click", undefined);
            setValues(_objectSpread(_objectSpread({}, values), {}, {
                imageList: imagesList
            }));
            return [2 /*return*/];
        });
    }); };
    var handleClose = function () {
        setImageURL("");
        setISDrawerOpen(false);
    };
    var handleClickImage = function (url) {
        setImageURL(url);
        setISDrawerOpen(true);
    };
    var onClickRemovePhotoIcon = function (items, photoIndex) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedPhotoList, imageItemToDelete, updatedImagesToRemove;
        return __generator(this, function (_a) {
            trackButtonClick("ButtonClickEvent", "RemovePhoto_Click", undefined);
            updatedPhotoList = __spreadArray([], values.imageList, true);
            imageItemToDelete = updatedPhotoList[photoIndex];
            if (imageItemToDelete && imageItemToDelete.AttachmentId) {
                updatedImagesToRemove = __spreadArray([], removedImages, true);
                updatedImagesToRemove.push(imageItemToDelete);
                setRemovedImages(updatedImagesToRemove);
            }
            updatedPhotoList.splice(photoIndex, 1);
            setValues(_objectSpread(_objectSpread({}, values), {}, {
                imageList: updatedPhotoList
            }));
            return [2 /*return*/];
        });
    }); };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleMenuItemClick = function (item) {
        // setSelectedItem(item);
        setSelectedViewType(item);
        handleCloseViewTypeMenu();
    };
    var handleCloseViewTypeMenu = function () {
        setAnchorEl(null);
    };
    var handleRemoveImageViewCondition = function (selectedItem, faultType) {
        var updatedList = __spreadArray([], preCheckList, true);
        var updatedItemIndex = updatedList.findIndex(function (item) { return item.ProductConditionCheckListItemId === selectedItem.ProductConditionCheckListItemId; });
        if (updatedItemIndex > -1) {
            var updatedItem = _objectSpread({}, updatedList[updatedItemIndex]);
            var updatedAnswers = updateDefaultValue(updatedItem.Answers, faultType);
            updatedItem.Answers = updatedAnswers;
            updatedList[updatedItemIndex] = updatedItem;
            setPrecheckList(updatedList);
            updatedAnswers.map(function (item) {
                if (item !== null && item !== void 0 && item.defaultValue) {
                    setSaveCount(saveCount + 1);
                }
            });
            dispatch(setIsTaskDetailsDataUpdated(true));
        }
        var updatedViewGroups = __spreadArray([], imageViewTypesTabs, true);
        var updateGroupItemIndex = updatedViewGroups.findIndex(function (item) { return item.ProductConditionViewId === selectedItem.ProductConditionViewId; });
        if (updateGroupItemIndex > -1) {
            var updateGroupItem = _objectSpread({}, updatedViewGroups[updateGroupItemIndex]);
            var updatedItemIndex_2 = updateGroupItem.checkListItems.findIndex(function (item) { return item.ProductConditionCheckListItemId === selectedItem.ProductConditionCheckListItemId; });
            if (updatedItemIndex_2 > -1) {
                var updatedItem = _objectSpread({}, updateGroupItem.checkListItems[updatedItemIndex_2]);
                var updatedAnswers = updateDefaultValue(updatedItem.Answers, faultType);
                updatedItem.Answers = updatedAnswers;
                updateGroupItem.checkListItems[updatedItemIndex_2] = updatedItem;
                updatedViewGroups[updateGroupItemIndex] = updateGroupItem;
            }
        }
        setImageViewTypesTabs(updatedViewGroups);
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2,
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(CustomFormFuelIndicator, {
        data: localFuelIndicatorData,
        onChangeList: function (list) { return setLocalFuelIndicatorData(list); },
        isDisabled: isDisabled
    }), /*#__PURE__*/ React.createElement(Divider, null), preCheckList.length > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center',
        justifyContent: 'space-between'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'lg',
        fontWeight: 'medium'
    }, t("Vehicle condition")), /*#__PURE__*/ React.createElement(MuiStack, {
        justifyContent: 'space-between'
    }, Module === isModuleConfig.Product && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 0.8
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h2",
        sx: {
            color: systemColor.primary
        },
        onClick: handleClick
    }, !selectedViewType ? E_VehicleConditionView.List : selectedViewType), /*#__PURE__*/ React.createElement("img", {
        style: {
            width: '20px',
            height: '20px'
        },
        id: 'vehicle-condition-dropdown',
        src: BlueDropdownIcon,
        onClick: handleClick,
        alt: "setting"
    }), !isDisabled && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Menu, {
        disableScrollLock: true,
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: handleCloseViewTypeMenu
    }, Object.values(E_VehicleConditionView).map(function (item, index) {
        if (item.Name == 'Select')
            return null;
        return /*#__PURE__*/ React.createElement(MenuItem, {
            sx: {
                width: "130px"
            },
            key: index,
            onClick: function () { return handleMenuItemClick(item); }
        }, item);
    }))))))), selectedViewType === E_VehicleConditionView.List && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        borderRadius: '8px',
        bgcolor: {
            xs: '#F4F7FA',
            sm: '#FFFFFF'
        },
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '14px',
        fontWeight: 400
    }, t("Scratch"), ": "), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "S")), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '14px',
        fontWeight: 400
    }, t("Damage"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "D")), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: '14px',
        fontWeight: 400
    }, t("Missing"), ":"), /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "M")))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '70%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, t("Section"))), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "S")), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "D")), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "caption"
    }, "M"))), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        width: '100%'
    }, preCheckList.map(function (option, index) { /*#__PURE__*/ return React.createElement(MuiStack, {
        key: index,
        width: '100%',
        alignItems: 'center',
        borderBottom: '1px solid #DEE4EB',
        paddingTop: index === 0 ? 0 : 1,
        paddingBottom: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        width: '70%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h4"
    }, option.Question)), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "scratch-checkbox",
        sx: {
            "& .MuiCheckbox-root": {
                padding: 0
            },
            opacity: isDisabled ? 0.7 : 1
        },
        disabled: isDisabled,
        checkBoxValue: getChecked(option.Answers, EFaultType.Scratch),
        handleChange: function () { return handleCheckboxChange(option.ID, index, EFaultType.Scratch); }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "damage-checkbox",
        sx: {
            "& .MuiCheckbox-root": {
                padding: 0
            },
            opacity: isDisabled ? 0.7 : 1
        },
        disabled: isDisabled,
        checkBoxValue: getChecked(option.Answers, EFaultType.Damage),
        handleChange: function () { return handleCheckboxChange(option.ID, index, EFaultType.Damage); }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '10%',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
        id: "missing-checkbox",
        sx: {
            "& .MuiCheckbox-root": {
                padding: 0
            },
            opacity: isDisabled ? 0.7 : 1
        },
        disabled: isDisabled,
        checkBoxValue: getChecked(option.Answers, EFaultType.Missing),
        handleChange: function () { return handleCheckboxChange(option.ID, index, EFaultType.Missing); }
    }))); }))), selectedViewType === E_VehicleConditionView.Image && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        bgcolor: {
            xs: 'secondary.50',
            sm: '#FFFFFF'
        },
        borderRadius: '8px',
        spacing: 1
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'normal'
    }, t("Scratch"), ": "), /*#__PURE__*/ React.createElement("div", {
        style: {
            borderRadius: "50%",
            height: "16px",
            width: "16px",
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.SCRATCH
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'normal'
    }, t("Damage"), ":"), /*#__PURE__*/ React.createElement("div", {
        style: {
            borderRadius: "50%",
            height: "16px",
            width: "16px",
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.DAMAGE
        }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0.5,
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: 'base',
        fontWeight: 'normal'
    }, t("Missing"), ":"), /*#__PURE__*/ React.createElement("div", {
        style: {
            borderRadius: "50%",
            height: "16px",
            width: "16px",
            backgroundColor: VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR.MISSING
        }
    })))), /*#__PURE__*/ React.createElement(ImageViewCustomTabs, {
        variant: "h3",
        items: imageViewTypesTabs,
        handleConditionChange: handleImageViewConditionChange,
        handleRemoveCondition: handleRemoveImageViewCondition,
        isDisabled: isDisabled
    }))), /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(PrecheckCustomForm, {
        data: precheckDynamicList,
        onChangeList: function (list) { return setPrecheckDynamicList(list); },
        isDisabled: isDisabled,
        isDataUpdated: function (value) { }
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        paddingBottom: 2,
        direction: "column",
        spacing: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            variant: {
                xs: 'h2',
                sm: 'h5'
            },
            fontSize: 'lg',
            fontWeight: 'medium'
        }
    }, t("Service advisor observations")), /*#__PURE__*/ React.createElement(Grid, {
        xs: 12,
        justifyContent: "center",
        bgcolor: "white",
        borderRadius: "8px"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 0,
        sx: {
            border: "1px solid #DEE4EB",
            borderBottom: 0,
            borderRadius: "8px 8px 0px 0px"
        },
        width: "100%"
    }, /*#__PURE__*/ React.createElement(TextField, {
        id: "multiline-input-sa-observation",
        placeholder: t("ENTER_SA_COMMENT_PLACEHOLDER"),
        multiline: true,
        rows: 3,
        fullWidth: true,
        value: values.description,
        sx: {
            "& fieldset": {
                border: "none"
            }
        },
        style: {
            margin: 0,
            opacity: isDisabled ? 0.5 : 1
        },
        onChange: function (event) {
            var _event$target$value, _event$target;
            setValues(_objectSpread(_objectSpread({}, values), {}, {
                description: (_event$target$value = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : ""
            }));
            ;
            ;
        },
        disabled: isDisabled
    })), /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "column",
        sx: {
            border: "1px solid #DEE4EB",
            borderRadius: "0px 0px 8px 8px",
            padding: '16px'
        },
        width: "100%"
    }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement("div", {
        style: {
            left: "8px",
            bottom: 10
        }
    }, /*#__PURE__*/ React.createElement(IconButton, {
        disabled: isDisabled
    }, /*#__PURE__*/ React.createElement(GalleryIcon, {
        sx: {
            color: systemColor.primary
        },
        onClick: function () { return handleOpenGalleryClick(); }
    })), /*#__PURE__*/ React.createElement(ImageCapture, {
        downloadedImages: (_values$imageList = values.imageList) !== null && _values$imageList !== void 0 ? _values$imageList : [],
        isOpen: openImageGallery,
        handleClose: function () { return handleOpenGalleryClick(); },
        handleImageList: function (list, removedImageList) { return handleImageList(list, removedImageList); }
    }))), values.imageList && /*#__PURE__*/ React.createElement(MuiStack, {
        direction: "row",
        spacing: 2,
        flexWrap: "wrap",
        paddingX: 2
    }, (_values$imageList2 = values.imageList) === null || _values$imageList2 === void 0 ? void 0 : _values$imageList2.slice(0, 3).map(function (image, photoIndex) { /*#__PURE__*/ return React.createElement("div", {
        key: photoIndex,
        style: {
            position: "relative",
            width: "80px",
            height: "80px",
            overflow: "hidden",
            borderRadius: "8px",
            marginBottom: "10px"
        }
    }, !isDisabled && /*#__PURE__*/ React.createElement(GridCloseIcon, {
        id: "remove-img-btn",
        onClick: function () { return onClickRemovePhotoIcon(image, photoIndex); },
        sx: {
            position: "absolute",
            zIndex: 1,
            right: 5,
            top: 5,
            backgroundColor: "white",
            height: "16px",
            width: "16px",
            borderRadius: "50%",
            cursor: "pointer"
        }
    }), /*#__PURE__*/ React.createElement("img", {
        src: image.blobUrl,
        alt: "Image ".concat(photoIndex + 1),
        style: {
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            cursor: "pointer"
        },
        onClick: function () { return handleClickImage(image.blobUrl); }
    })); })), isDrawerOpen && /*#__PURE__*/ React.createElement(MuiImagePopUp, {
        isOpen: isDrawerOpen,
        onClose: handleClose,
        image: imageURL
    })))), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Divider, {
        sx: {
            width: '100%'
        }
    })), isSaveButton && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: "flex-end"
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        variant: "outlined",
        color: "primary",
        style: {
            width: "60px"
        },
        loading: loader.isLoaderOpen,
        name: t('Save'),
        id: "precheckSave",
        disabled: isDisabled,
        onClick: onClickSave
    })));
};
export default PreCheckCommonComponent;
